var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 6.58138L11.375 11.7064C11.2222 11.9286 11.0244 12.1022 10.7817 12.2272C10.5383 12.3522 10.2778 12.4147 10 12.4147H1.66667C1.20833 12.4147 0.815833 12.2517 0.489167 11.9255C0.163055 11.5989 0 11.2064 0 10.748V2.41471C0 1.95638 0.163055 1.56416 0.489167 1.23805C0.815833 0.91138 1.20833 0.748047 1.66667 0.748047H10C10.2778 0.748047 10.5383 0.810547 10.7817 0.935547C11.0244 1.06055 11.2222 1.23416 11.375 1.45638L15 6.58138ZM12.9583 6.58138L10 2.41471H1.66667V10.748H10L12.9583 6.58138Z",
    fill: "#C2C2C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagIcon);
export default __webpack_public_path__ + "static/media/TagIcon.6060736a8531cd8ed92f92ad6dad774f.svg";
export { ForwardRef as ReactComponent };